var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMypage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#404145",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21.667 22.75v-2.167c0-1.149-.457-2.251-1.27-3.064-.812-.813-1.914-1.269-3.064-1.269H8.667c-1.15 0-2.252.456-3.064 1.27-.813.812-1.27 1.914-1.27 3.063v2.167M13 11.917c2.393 0 4.333-1.94 4.333-4.334 0-2.393-1.94-4.333-4.333-4.333-2.393 0-4.333 1.94-4.333 4.333 0 2.394 1.94 4.334 4.333 4.334z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMypage);
export default __webpack_public_path__ + "static/media/icon-mypage.8a4e5307.svg";
export { ForwardRef as ReactComponent };